$(document).ready(function() {   

 // wholesale page image banner btn links
$('#wholesale .hero-section .hero__button a').attr('target', '_blank');


$(".ShopALL_img").prependTo(".drawer__main-menu-img");
  
  
var $swiperSelector = $('#swiper-container_1');
$swiperSelector.each(function (index) {
  var $this = $(this);
  $this.addClass('swiper-slider-' + index);

  var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 180;
  var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
  var loop = $this.data('loop') ? $this.data('loop') : false;
  var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 4.5;
  var slidesLap = $this.data('slides-Lap') ? $this.data('slides-lap') : 4.5;
  var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 3;
  var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 4;
  var spaceBetween = $this.data('space-between') ? $this.data('space-between') : -2;
  var swiper = new Swiper('.swiper-slider-' + index, {
    direction: 'horizontal',
    loop: loop,
    freeMode: freeMode,
    spaceBetween: spaceBetween,
    breakpoints: {
      1920: {
        slidesPerView: slidesDesktop },

      1150: {
        slidesPerView: slidesLap },

      992: {
        slidesPerView: slidesTablet },

      767: {
        slidesPerView: slidesMobile } },

    navigation: {
      nextEl: '.swiper-button-next_1',
      prevEl: '.swiper-button-prev_1' },

    scrollbar: {
      el: '.swiper-scrollbar_1',
      draggable: true,
      dragSize: dragSize } });
});
//# sourceURL=pen.js




var $swiperSelector_2 = $('#swiper-container_2');
$swiperSelector_2.each(function (index) {
  var $this = $(this);
  $this.addClass('swiper-sliders-' + index);

  var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 180;
  var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
  var loop = $this.data('loop') ? $this.data('loop') : false;
  var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 3;
  var slidesLap = $this.data('slides-Lap') ? $this.data('slides-lap') : 3;
  var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 3;
  var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 1.5;
  var spaceBetween = $this.data('space-between') ? $this.data('space-between') : -2;
  var swipers = new Swiper('.swiper-sliders-' + index, {
    direction: 'horizontal',
    loop: loop,
    freeMode: freeMode,
    spaceBetween: spaceBetween,
    breakpoints: {
      1920: {
        slidesPerView: slidesDesktop },

      1150: {
        slidesPerView: slidesLap },

      992: {
        slidesPerView: slidesTablet },

      767: {
        slidesPerView: slidesMobile } },

    navigation: {
      nextEl: '.swiper-button-next_2',
      prevEl: '.swiper-button-prev_2' },

    scrollbar: {
      el: '.swiper-scrollbar_2',
      draggable: true,
      dragSize: dragSize } });
});
//# sourceURL=pen.js
  
 setTimeout(function() {
//   $('#frequently-asked-questions .faq_accordion_box').wrapAll('<div class="faq_row"></div>');
  }, 100);

  setTimeout(function() {
//  $(".faqpage_links").prependTo(".faq_row");
  }, 300);



$("#faqpage_links a:nth-child(1)").click(function() {
    $('html, body').animate({ scrollTop: $("#orders-and-returns_box").offset().top - 115 }, 300);
});  
  $("#faqpage_links a:nth-child(2)").click(function() {
    $('html, body').animate({ scrollTop: $("#subscription_box").offset().top - 115 }, 300);
});
  $("#faqpage_links a:nth-child(3)").click(function() {
    $('html, body').animate({ scrollTop: $("#shipping_box").offset().top - 115 }, 300);
});
  $("#faqpage_links a:nth-child(4)").click(function() {
    $('html, body').animate({ scrollTop: $("#product-questions_box").offset().top - 115 }, 300);
});
  $("#faqpage_links a:nth-child(5)").click(function() {
    $('html, body').animate({ scrollTop: $("#rewards-program_box").offset().top - 115 }, 300);
});
  $("#faqpage_links a:nth-child(6)").click(function() {
    $('html, body').animate({ scrollTop: $("#general_box").offset().top - 115 }, 500);
});


  
});



$(window).scroll(function() {
		var scrollDistance = $(window).scrollTop();

	
		// Assign active class to nav links while scolling
		$('.accordion_mune').each(function(i) {
				if ($(this).position().top <= scrollDistance + 130) {
						$('#faqpage_links a.active').removeClass('active');
						$('#faqpage_links a').eq(i).addClass('active');
				}
		});
}).scroll();












